import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// client js begin
import html2canvas from 'html2canvas'; // 这个不支持服务端渲染，所以用了 \/\/ client js begin 打包的时候去除掉
// client js end

export default {
  data: function data() {
    return {
      base64Str: '',
      generated: false,
      processing: false,
      maskStyle: {
        height: '100%',
        width: '100%'
      },
      clientRect: null,
      params: {
        type: 'image/png',
        encoderOptions: 1,
        autoReplace: true,
        // 默认自动将生成的图片替换掉原来的DOM节点
        maskColor: '#eddeb3',
        // 生成图片时遮罩的颜色
        useCORS: true,
        // ---以下复用html2canvas参数
        scale: 2,
        backgroundColor: null,
        logging: true
      }
    };
  },
  methods: {
    generate: function generate() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, canvas, ctx;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                _this.params = _objectSpread(_objectSpread({}, _this.params), params); // 生成图片

                _context.prev = 2;
                _this.clientRect = _this.$el.getBoundingClientRect();
                _this.$el.style.width = "".concat(Math.round(_this.clientRect.width), "px");
                _this.$el.style.height = "".concat(Math.round(_this.clientRect.height), "px");
                _this.processing = true;
                _context.next = 9;
                return html2canvas(_this.$el, _this.params);

              case 9:
                canvas = _context.sent;

                if (params.disableSmoothing) {
                  ctx = canvas.getContext('2d');
                  ctx.mozImageSmoothingEnabled = false;
                  ctx.webkitImageSmoothingEnabled = false;
                  ctx.msImageSmoothingEnabled = false;
                  ctx.imageSmoothingEnabled = false;
                }

                _this.base64Str = canvas.toDataURL(_this.params.type, _this.params.encoderOptions);
                _this.generated = true;
                _this.processing = false;

                _this.$emit('success', _this.base64Str);

                return _context.abrupt("return", _this.base64Str);

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](2);

                _this.$emit('fail', _context.t0);

                return _context.abrupt("return", '');

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 18]]);
      }))();
    }
  },
  install: function install() {},
  watch: {
    clientRect: function clientRect(newVal) {
      if (newVal) {
        this.maskStyle.height = "".concat(newVal.height, "px");
        this.maskStyle.width = "".concat(newVal.width, "px");

        if (this.params.maskColor) {
          this.maskStyle.backgroundColor = this.params.maskColor;
        }
      }
    }
  }
};